export default __webpack_public_path__ + "static/media/spot.ae0bd3ee.png";